//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FilePicker from '@/components/FilePicker'
import Poster from '@/api/promotores/posters.api'

export default {
  components: { FilePicker },

  props: {
    poster: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      poster_: {...this.poster},
      saving: false,
    }
  },

  methods: {
    show() {
      this.$refs.dialog.show()
    },
    hide() {
      this.$refs.dialog.hide()
    },
    async submit() {
      try {
        this.saving = true

        const response = (this.poster.id
          ? await Poster.update(this.poster.id, this.poster_)
          : await Poster.create(this.poster_))

        this.$emit('ok', this.poster_)
        this.hide();
      } finally {
        this.saving = false
      }
    }
  }
}
